import { Typography } from '../../atoms';
import pdffooterftlogo from '../../../assets/logos/pdffooterftlogo.svg';
import { Grid, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../common/hooks';

export interface PDFFooterProps {
    currentPage: number;
    totalPages: number;
    useSingleLineFooter?: boolean;
}

const TenantLogo = styled('img')(() => ({
    width: '238px',
    height: '46px'
}));

const StyledFooterTypography = styled(Typography)(({ theme }) => ({
    fontSize: '12px',
    lineHeight: theme.spacing(2)
}));

const FooterLine2 = styled('span')(() => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
}));

export const PDFFooter = ({ currentPage, totalPages, useSingleLineFooter }: PDFFooterProps) => {
    const { t } = useTranslation();
    const { globalConfig } = useAppSelector((state) => state.global);
    const logo = globalConfig?.logo;
    const isFranklinAdviceTenant = globalConfig?.subdomain === 'advice';

    const decideConditionalUiForLogo = () => {
        if (!isFranklinAdviceTenant && logo) {
            return <TenantLogo src={logo} alt="Franklin Templeton" />;
        }
        return <img src={pdffooterftlogo} alt="Franklin Templeton" width={370} height={20} />;
    };
    return (
        <Grid position={'absolute'} bottom={'0'} width={'100%'}>
            {!useSingleLineFooter && <Typography label={t('DESCRIPTION_FOOTER_ONE')} sx={{ fontSize: 14 }} />}
            <FooterLine2>
                {decideConditionalUiForLogo()}
                <StyledFooterTypography variant="body.smallDemibold" label={t('PDF_FOOTER_USAGE_TEXT') || ''} />
                <StyledFooterTypography
                    variant="body.smallDemibold"
                    label={`${currentPage} ${t('OF_TEXT')} ${totalPages}` || ''}
                />
            </FooterLine2>
        </Grid>
    );
};
